module.exports = __webpack_public_path__ + "static/img/6areaA_11.d8ca07d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/6areaA_11.png
// module id = 915
// module chunks = 1